module.exports = __webpack_public_path__ + "img/sub_25.490_5.882.d3678ad3.png";